import styled from "styled-components";
import { AuthBg, AuthLogo } from "@assets/auth";
import {
  Form as AntForm,
  // Divider as AntDivider,
  Input as AntInput,
  Typography,
  Button as AntButton
} from "antd";


export const RootContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-image: url(${AuthBg});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 0px 16px;

  .ant-btn-primary {
    width: 100%;
    height: 56px;
  }
  position: relative;
`;

export const NavContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  margin-top: 16px;
  height: 37px;/* need to add this to be the same height with nav from other auth pages */
`;

export const SkipButton = styled(AntButton)`
  display: inline-flex;
  padding: 7px 12px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  background-color: #212224;

  color: #FFB829;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`
export const Logo = styled(AuthLogo)`
  margin: 36px 0 0 0;
`

export const ContentContainer = styled.div`
  width: 100%;
  margin: 39px auto 24px;
`

export const Title = styled(Typography.Title)`
  color: #FFC654 !important;
  font-size: 20px !important;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-align: center;
`

export const Form = styled(AntForm)`
  margin-top: 24px;
  width: 100%;
  text-align: center;

  .ant-form-item-explain {
    text-align: left; /* align warning text to the left */
    margin-left: 8px;
  }

  .ant-form-item-label {
    margin: 0px 0 2px 8px;
    margin-left: 8px;
    text-align: left;
    padding: 0 !important;
  }

  .ant-form-item-label label {
    color: #DADADA;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

`;
export const Input = styled(AntInput)`
  -moz-appearance: textfield;
;
  padding-left: 17px;
  color: #0E1017;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  height: 56px;
  border-radius: 12px;

  &:focus{
    border: 2px solid #FFC654;
  }

  &::placeholder {
    color: #BFBFBF;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  appearance: textfield;
  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    -webkit-appearance: none; /* WebKit */
    margin: 0;
  }
  ::-webkit-inner-spin-button:disabled,
  ::-webkit-outer-spin-button:disabled {
    display: none;
  }
`;

export const ORText = styled.div`
  margin: 0 auto 45px !important;
  text-align: center;
  color: #FFF;
  font-size: 16px;
  font-style: normal;
  font-weight: 100;
  line-height: normal;
`

// export const Divider = styled(AntDivider)`
//   margin: 0 auto 24px !important;
//   padding: 0 52px;
  
//   .ant-divider-horizonta{
//     min-width: 254px;
//   }

//   .ant-divider-inner-text {
//     box-sizing: border-box;
//     color: #fff;
//     font-size: 14px;
//     font-family: Poppins;
//     font-style: normal;
//     font-weight: 400;
//     line-height: 24px;
//     background: #342309;
//     width: fit-content !important; /* Set the desired width */
//     height: 28px !important;
//     border-radius: 50%;
//     text-align: center !important; /* Optional, to center the text horizontally */
//     padding: 3px 7px;
//     margin-left: 24px;
//     margin-right: 24px;
//   }

//   ::before,
//   ::after {
//     border: 1px solid #e1cce0;
//     border-color: #FFD260 !important;
//   }
// `;

export const LoginButton = styled(AntButton)`
  color: #F9F9F9;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin: 0px 0 0 0;
`

export const TextButton = styled(AntButton)`
  float: right;
  text-align: right;
  color: #fff;
  margin: -30px 0 0 0;
  padding: 0 0px 0 0;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  &:hover{
    color: #fff !important;
  }
`
export const RegisterButton = styled(AntButton)`
  background-color: transparent !important;
  border: 2px solid #CC9321;
  border-radius: 12px;
  margin: 0 0 20px;
  color: #FFF;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;

  &:hover {
    background: transparent !important;
    color: white !important;
  }
`
export const GoogleLoginButton = styled.div`
margin-top: 24px;
width: 100%;
height: 52px;
border-radius: 10px;
display: flex;
gap: 10px;
align-items: center;
justify-content: center;
background-color: #fff;
cursor: pointer;
position: relative;

font-size: 14px;
font-weight: bold;

svg {
  width: 24px;
}

.ant-spin {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
`;


export const TelegramLoginButton = styled.div`
margin-top: 24px;
width: 100%;
height: 52px;
border-radius: 10px;
display: flex;
gap: 10px;
align-items: center;
justify-content: center;
background-color: #fff;
cursor: pointer;
position: relative;

font-size: 14px;
font-weight: bold;

svg {
  width: 24px;
}

.ant-spin {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
`;


export const SocialLoginWrapper = styled.div`
display:flex;
width:100%;
gap:20px;
align-items:center
`;